// extracted by mini-css-extract-plugin
export default {"root":"ContactModal_root__MzVqM","layout-container":"ContactModal_layout-container__Z6JbU","content":"ContactModal_content__JuhoN","buttonCopy":"ContactModal_buttonCopy__i2zEZ","buttonClose":"ContactModal_buttonClose__lCaRh","linkImage":"ContactModal_linkImage__-00yB","textContainer":"ContactModal_textContainer__4eNZ4","button":"ContactModal_button__YDXYj"};
    if(module.hot) {
      // 1763464084390
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  